export default {
  routes: {
    home: '/',
    subOrganization: '/storage/:orgId',
    createOrganization: '/organization/create',
  },
};
